import { render } from "./SwiPe.vue?vue&type=template&id=57e942fa&scoped=true"
import script from "./SwiPe.vue?vue&type=script&lang=js"
export * from "./SwiPe.vue?vue&type=script&lang=js"

import "./SwiPe.vue?vue&type=style&index=0&id=57e942fa&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e942fa"]])

export default __exports__